<template>
  <div v-rect-loading="loading" class="candidate-offer-detail">
    <div class="header">
      <i v-rect-loading="downloading" class="btn iconfont icona-ResumeDownload" @click="handleExportPDF"></i>
    </div>
    <div v-html="displayOfferLetterContent" class="container" ref="offerContentRef"></div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { AsyncTask } from '@/utils/common'
import mixin from '@/views/personalNew/offerLetter/mixin'

export default {
  mixins: [mixin],
  data () {
    return {
      i18nPrefix: 'personal.offerLetter',
      loading: false,
      downloading: false,
      offerInfo: {
        offer_letter_content: null,
        status: null
      },
      acceptInfo: {}
    }
  },
  computed: {
    inviteId () {
      return this.$route.params.inviteId
    },
    companyId () {
      return this.$route.query.company_id
    },
    displayOfferLetterContent () {
      if (this.offerInfo.offer_letter_content) {
        return this.formatContent(this.offerInfo.offer_letter_content, this.acceptInfo)
      }
      return ''
    },
    templateContentFields () {
      const content = this.offerInfo.offer_letter_content
      if (!content) {
        return []
      }
      const allKeys = this.getTemplateAllPlaceholder(content)
      const templateFields = _.chain(this.allTemplateFiledList).filter(item => _.includes(allKeys, item.key)).map(item => {
        item.order = _.findIndex(allKeys, key => key === item.key)
        return item
      }).orderBy('order').value()
      return templateFields
    }
  },
  created () {
    this.initPage()
  },
  mounted () {
    this.resetAcceptInfo()
  },
  methods: {
    ...mapActions('personal', ['getPersonalOfferLetterDetailById']),
    ...mapActions('application', [
      'createExportCandidateOfferLetterInfoTask',
      'getExportCandidateOfferLetterTaskStatus'
    ]),
    ...mapActions('offerLetter', ['getOfferLetterTemplateFieldList']),
    async initPage () {
      await this.loadTemplateFiledList()
      this.loadOfferDetail()
    },
    async loadOfferDetail () {
      this.loading = true
      try {
        const resp = await this.getPersonalOfferLetterDetailById(this.inviteId)
        if (resp) {
          this.offerInfo = resp
          this.resetAcceptInfo()
          this.$nextTick(() => {
            this.resetHeadImgStyle()
          })
        }
      } finally {
        this.loading = false
      }
    },
    async loadTemplateFiledList () {
      const resp = await this.getOfferLetterTemplateFieldList({ company_id: this.companyId })
      if (resp) {
        this.allTemplateFiledList = resp
      }
    },
    resetAcceptInfo () {
      _.forEach(this.templateContentFields, field => {
        if (!_.has(this.acceptInfo, field.key)) {
          this.$set(this.acceptInfo, field.key, null)
        }
      })
    },
    resetHeadImgStyle () {
      const offerContentRef = this.$refs.offerContentRef
      const headerImgEl = offerContentRef.querySelector('.offer-letter-head-img')
      if (!headerImgEl || !offerContentRef) {
        return
      }
      const offerContentStyle = window.getComputedStyle(offerContentRef)
      const offerContentWidth = offerContentRef.clientWidth - _.parseInt(offerContentStyle.paddingLeft) - _.parseInt(offerContentStyle.paddingRight)
      const ratios = offerContentWidth / 580
      const headerImgWidth = headerImgEl.clientWidth * ratios
      const headerImgHeight = headerImgEl.clientHeight * ratios
      headerImgEl.style.width = `${headerImgWidth}px`
      headerImgEl.style.height = `${headerImgHeight}px`
    },
    handleExportPDF () {
      this.downloading = true
      const exportOfferLetterPdfStatus = {
        finished: false,
        task: null
      }
      exportOfferLetterPdfStatus.finished = false
      exportOfferLetterPdfStatus.task = new AsyncTask(() => this.createExportCandidateOfferLetterInfoTask({
        candidate_id: this.offerInfo.candidate_id,
        job_id: this.offerInfo.job_id
      }), (taskId) => this.getExportCandidateOfferLetterTaskStatus({
        task_id: taskId
      }), (taskId) => {
        const downloadEl = document.createElement('a')
        downloadEl.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/offer-letter/?task_id=${taskId}&download=1`)
        downloadEl.click()
        exportOfferLetterPdfStatus.finished = false
        exportOfferLetterPdfStatus.task = null
        this.downloading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-offer-detail {
  .header {
    text-align: right;
    margin: 0 auto;
    background-color: #fff;
    padding: 30px 44px 0 44px;
    .btn {
      display: inline-block;
      font-size: 20px;
      color: #0096cc;
      cursor: pointer;
    }
    ::v-deep {
      .el-loading-spinner {
        margin-top: -12px;

        .loading-spinner {
          .spinner {
            width: 20px;
            height: 20px;

            >div {
              width: 3px;
            }
          }
        }
      }
    }
  }
  .container {
    background: #fff;
    padding: 2px 44px 54px 44px;
    margin: 0 auto;
  }
}
</style>
